import api from 'src/config/api';
import {
	IAIModel,
	ICreateAIModelRequest,
	IGetAIModelsParams,
	IUpdateAIModelRequest,
} from 'src/features/ai_model/domain/types';

export const AIModelApi = {
	createAIModel: async (
		requestBody: ICreateAIModelRequest,
		siteSlug: string,
	): Promise<IAIModel> => {
		const response = await api.post(`/api/v1/ai-model`, requestBody, {
			headers: { Site: siteSlug },
		});
		return response.data;
	},

	updateAIModel: async (
		id: number,
		requestBody: IUpdateAIModelRequest,
		siteSlug: string,
	): Promise<IAIModel> => {
		const response = await api.patch(
			`/api/v1/ai-model/${id}`,
			requestBody,
			{
				headers: { Site: siteSlug },
			},
		);
		return response.data;
	},

	getAIModels: async (
		requestParams: IGetAIModelsParams,
		siteSlug: string,
	): Promise<IPaginatedResponse<IAIModel>> => {
		const { page = 1, active, order, sort } = requestParams;

		const params = new URLSearchParams({
			page: page.toString(),
			...(sort && order && { sort, order }),
			...(active && { active }),
		});

		const response = await api.get(`/api/v1/ai-models?${params}`, {
			headers: { Site: siteSlug },
		});
		return response.data;
	},

	getAIModel: async (id: number, siteSlug: string): Promise<IAIModel> => {
		const response = await api.get(`/api/v1/ai-model/${id}`, {
			headers: { Site: siteSlug },
		});
		return response.data;
	},

	deleteAIModel: async (id: number, siteSlug: string): Promise<void> => {
		await api.delete(`/api/v1/ai-model/${id}`, {
			headers: { Site: siteSlug },
		});
	},
};
